import { ProductivityManagerTabsEnum } from '@/modules/productivity/types';
import { ProductivityDetailsTabsEnum } from '@/modules/productivity/views/builder/types';

import { PARENT_ROUTE as ADMIN_PARENT_ROUTE } from './admin';

const productivityAdminRoutes = {
  ProductivityManager: () => `${ADMIN_PARENT_ROUTE}/productivity`,
  ProductivityManagerCreate: () => `${ADMIN_PARENT_ROUTE}/productivity/create`,
  ProductivityManagerTab: (tab: ProductivityManagerTabsEnum) =>
    `${ADMIN_PARENT_ROUTE}/productivity/${tab}`,
  ProductivityManagerTeam: () =>
    `${ADMIN_PARENT_ROUTE}/productivity/${ProductivityManagerTabsEnum.Team}`,
  ProductivityManagerTeamCreate: () =>
    `${ADMIN_PARENT_ROUTE}/productivity/${ProductivityManagerTabsEnum.Team}/create`,
  ProductivityManagerTeamEdit: ({
    orgRoleId,
    departmentId,
    userId,
    initialTab,
  }: {
    orgRoleId: string;
    departmentId: string;
    userId?: string;
    initialTab: string;
  }) =>
    `${ADMIN_PARENT_ROUTE}/productivity/${
      ProductivityManagerTabsEnum.Team
    }/edit?orgRoleId=${orgRoleId}&departmentId=${departmentId}${
      userId ? `&userId=${userId}` : ''
    }&selectedTab=${initialTab}`,
  ProductivityDetails: (id: string) => `${ADMIN_PARENT_ROUTE}/productivity/details/${id}`,
  AdminViewUserMgsa: (userId: string) => `${ADMIN_PARENT_ROUTE}/mgsa/users/${userId}/details`,
};

const productivityRoutes = {
  ViewUserMgsa: (userId: string, selectedTab?: string) =>
    `/mgsa/users/${userId}/details${selectedTab ? `?selectedTab=${selectedTab}` : ''}`,
  CreateUserMgsa: (userId: string, orgRoleId: string, departmentId: string) =>
    `/mgsa/users/${userId}/create-user?orgRoleId=${orgRoleId}&userId=${userId}&departmentId=${departmentId}&selectedTab=${ProductivityDetailsTabsEnum.Mindsets}`,
  EditUserMgsa: (userId: string, orgRoleId: string, departmentId: string, selectedTab?: string) =>
    `/mgsa/users/${userId}/edit?orgRoleId=${orgRoleId}&userId=${userId}&departmentId=${departmentId}&selectedTab=${
      selectedTab || ProductivityDetailsTabsEnum.Mindsets
    }`,
  EditTeamMgsa: (userId: string) => `/mgsa/users/${userId}/edit-team`,
};

const routes = {
  ...productivityAdminRoutes,
  ...productivityRoutes,
};
export default routes;
